import { render } from "./StatViewManager.vue?vue&type=template&id=a1d3a59a&scoped=true"
import script from "./StatViewManager.vue?vue&type=script&lang=js"
export * from "./StatViewManager.vue?vue&type=script&lang=js"

import "./StatViewManager.vue?vue&type=style&index=0&id=a1d3a59a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1d3a59a"]])

export default __exports__